
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Define the animation logic
const initAnimations = () => {

    gsap.utils.toArray(".testSection").forEach(section => {
        ScrollTrigger.create({
            trigger: section,
            start: "top 60px", // Start when the section hits the top of the viewport
            end: "bottom 65px",
            snap: 1,
            pin: false,
            scrub: true,

        });
    });

};

gsap.registerPlugin(ScrollTrigger);


//initAnimations();
function checkScreenSize() {
    if (window.innerWidth > 1270) {
        initAnimations();
    }
}
checkScreenSize();
window.addEventListener('resize', checkScreenSize);